import { defineComponent as _defineComponent } from 'vue'
import StreamContainer from './StreamContainer.vue';
import RoomSidebar from '../../components/RoomSidebar/index.vue';
import RoomModel from '../../components/RoomModel/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    showRoomTool: { type: Boolean }
  },
  emits: ['on-destroy-room', 'on-exit-room'],
  setup(__props: any, { emit }) {





const onDestroyRoom = (info: { code: number; message: string, data:any }) => {
  emit('on-destroy-room', info);
};

const onExitRoom = (info: { code: number; message: string, data:any }) => {
  emit('on-exit-room', info);
};

return { __sfc: true,emit, onDestroyRoom, onExitRoom, StreamContainer, RoomSidebar, RoomModel }
}

})